import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import logoImg from '../assets/images/logo.png';
import { usePriceFetchStats } from '../stats/useStats';
import iconImg from '../assets/images/icon.png';
import { formatPrice } from '../hooks/contractHelper';
import { menuItems } from '../hooks/constant';



export default function Sidebar() {
    const router = useLocation();
    const priceStats = usePriceFetchStats()


    return (
        <div className="sidebar">
            <div className="logo-wrap">
                <Link to="/" >
                    <img src={logoImg} className="logo" alt="logo" />
                </Link>
            </div>
            <nav>
                <ul className="sidebar-nav mb-5">
                    {menuItems.map((item, index) => {
                        
                        return (
                            <li key={index}>
                                {item.external ? (
                                    <a href={item.url} target="_blank" rel="noreferrer" className={`${router.pathname === item.url ? 'active' : ''}`}>
                                        <span className="icon-wrap">
                                            {item.icon ? (
                                                <i className={item.icon}></i>
                                            ) : (
                                                item.image && <img src={item.image} alt={`${item.name}-logo`} width={30} height={30} />
                                            )}
                                        </span>
                                        <span className="link-name">{item.name}</span>
                                    </a>
                                ) : (
                                    <Link to={item.url} className={`${router.pathname === item.url ? 'active' : ''}`}>
                                        <span className="icon-wrap">
                                            {item.icon ? (
                                                <i className={item.icon}></i>
                                            ) : (
                                                item.image && <img src={item.image} alt={`${item.name}-logo`} width={30} height={30} />
                                            )}
                                        </span>
                                        <span className="link-name">{item.name}</span>
                                    </Link>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </nav>
            <div className='d-flex justify-content-center align-items-center p-1' style={{ position: "fixed", bottom: "10px", "left": "15px" }}>
                <a
                    href="https://mgpswap.com/swap/"
                    target="_blank"
                    rel="noreferrer"
                    className="d-flex align-items-center text-decoration-none mx-1"
                >
                    <img src={iconImg} style={{ height: '24px', width: '24px' }} alt='banner' />
                    <span className="mx-1" style={{ fontSize: '14px' }}>
                        ${formatPrice(priceStats.price, 3)}
                    </span>
                </a>
                <a
                    href="https://mgpswap.com/swap/"
                    target="_blank"
                    rel="noreferrer"
                    className='tf-button buy-button d-flex align-items-center'

                >
                    Buy Now
                    <svg
                        className='ml-1'
                        viewBox="0 0 24 24"
                        width="16"
                        height="16"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ marginLeft: '8px' }}
                    >
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </a>
            </div>
        </div>
    )
}
